import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import styles from '../../styles/main.scss';

// components
import Text from '../inputs/Text';

const messages = defineMessages({
    placeholder: {
        id: 'dc.AddressForm.Company.placeholder',
        defaultMessage: 'Company (optional)',
    },
});

const CompanyInput = ({
    value,
    autoFocus,
    fieldSize,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur,
}) => {
    const intl = useIntl();
    return (
        <Text
            name="company"
            dataTn="company"
            value={value}
            wrapperClass={styles.group}
            placeholder={intl.formatMessage(messages.placeholder)}
            autoComplete="organization"
            autoFocus={autoFocus}
            fieldSize={fieldSize}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

CompanyInput.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    autoFocus: PropTypes.bool,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
};

CompanyInput.defaultProps = {
    autoFocus: false,
    onBlur() {},
};

export default CompanyInput;
